import React from "react";
import { Box } from "@material-ui/core";
import FilterListIcon from "@material-ui/icons/FilterList";
import CustomButton from "../Button/CustomButton";
import CustomContextMenu from "../Menu/CustomContextMenu";

export enum GeneralFileType {
  ALL = "All",
  IMAGES = "Only Pictures",
  DOCUMENTS = "Only Documents",
}

export interface GalleryFilterProps {
  generalFileType: keyof typeof GeneralFileType;
  setGeneralFileType: (generalFileType: keyof typeof GeneralFileType) => void;
}

function GalleryFilter(props: GalleryFilterProps) {
  const { generalFileType, setGeneralFileType } = props;

  return (
    <CustomContextMenu
      buttonContent={(handleClick) => (
        <CustomButton
          text={`Show ${GeneralFileType[generalFileType]}`}
          startIcon={
            <Box width={22} paddingTop={0.5} marginRight={1}>
              <FilterListIcon fontSize="small" />
            </Box>
          }
          onClick={handleClick}
        />
      )}
      data={Object.keys(GeneralFileType)
        .map((k) => k as keyof typeof GeneralFileType)
        .map((s) => ({
          id: s,
          label: GeneralFileType[s],
        }))}
      active={generalFileType}
      onMenuItemClick={(x) => setGeneralFileType(x.id as keyof typeof GeneralFileType)}
    />
  );
}

export default GalleryFilter;
